import { HTMLMotionProps } from 'motion/react'

// requires a parent with overflow: hidden. Overrides class name, so use parent instead.
export function simpleWipe(direction: 'up' | 'down' = 'up'): HTMLMotionProps<'div'> {
	return {
		className: 'relative block',
		initial: {
			translateY: direction === 'up' ? '100%' : '-100%',
		},
		animate: {
			translateY: '0%',
		},
		exit: {
			translateY: direction === 'up' ? '-100%' : '100%',
		},
	}
}

// old version -- this scaled by width, so could cause trouble with long text
// export function simpleWipe({ animateWidth = true }: { animateWidth?: boolean } = {}): HTMLMotionProps<'div'> {
// 	return {
// 		initial: {
// 			clipPath: 'inset(0 100% 0 0)',
// 			width: animateWidth ? '0%' : 'auto',
// 			overflow: 'hidden',
// 			whiteSpace: animateWidth ? 'nowrap' : 'normal',
// 		},
// 		animate: {
// 			clipPath: 'inset(0 0 0 0)',
// 			width: 'auto',
// 			overflow: 'hidden',
// 		},
// 		exit: {
// 			clipPath: 'inset(0 0 100% 0)',
// 			width: animateWidth ? '0%' : 'auto',
// 			overflow: 'hidden',
// 			whiteSpace: animateWidth ? 'nowrap' : 'normal',
// 		},
// 	}
// }
